import React, { Fragment, useEffect, useState } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../styles/balanco.scss'
import moment from "moment";

const Pesquisa = (props) => {

    const [media, setMedia] = useState(null);

    useEffect(() => {
        const calcularMedia = async () => {
            if (props.pesquisa && props.pesquisa.avaliacao && props.pesquisa.avaliacao.length > 0) {
                const total = props.pesquisa.avaliacao.reduce((acc, curr) => acc + curr.nota, 0);
                const media = total / props.pesquisa.avaliacao.length;
                setMedia(media.toFixed(1));
            }
        };

        calcularMedia();
    }, [props.pesquisa]);

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });
    const dataCad = moment(props.pesquisa.dataCad).utc(false).format("DD/MM/YYYY");

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchPesquisas()
    }


    const chunkArray = (array, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    };

    const chunks = chunkArray(props.pesquisa.avaliacao, 7);



    return (
        <Fragment>
            <Col>
                <Card>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>Pesquisa Nº{props.pesquisa._id}</Card.Title>
                        <p>Data de Cadastro: {dataCad}</p>
                        {media !== null ? (
                            <p style={{fontSize: '24px'}}>Nota média: <strong>{media}/5</strong></p>
                        ) : (
                            <p>Carregando...</p>
                        )}
                        <hr />
                        Mensagem deixada: {props.pesquisa.mensagem ? <p>{props.pesquisa.mensagem}</p> : null}
                        <hr />
                        <Row xs={12} lg={3}>
                            {chunks.map((chunk, chunkIndex) => (
                                <Col key={chunkIndex}>
                                    {chunk.map((ava, index) => (
                                        <p key={index}>{ava.orgao}: Nota {ava.nota}</p>
                                    ))}
                                </Col>
                            ))}
                        </Row>
                    </Card.Body>
                    <hr />
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.pesquisa._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Pesquisa;